<template>
  <div class="animated fadeIn">

    <b-row>
      <b-col lg="12">
      <!--  <b-breadcrumb :items="breadcrumbs"/>   -->  
       <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <strong>  Received Dashboard  of Cash </strong>  
        </div>
        <b-row class="mb-4">          
         <!--  <b-col md="6" class="my-1">
            <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col> -->
          <b-col md="12" class="my-1">
            <form > 
            <b-row class="form-group">
              <b-col sm="4">
                <b-col sm="12" >
                <b-form-group label="From Date:"  :label-cols="4" >
                 <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                </v-date-picker>
                </b-form-group>
              </b-col>
              </b-col >
              <b-col sm="4" id="todatpick"  >
                <b-form-group label="To Date:" :label-cols="4" >
                  <v-date-picker   autoclose="true"   mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>
              </b-col>

                 <b-col cols="4">
                <b-button size="md" variant="primary" @click="showCSV"> Search</b-button>&nbsp;&nbsp;&nbsp;
                 
              </b-col>

            </b-row>               
            </form>              
          </b-col> 
            <div id="overlay" >
             <div class="loader"></div>
           </div>    
           <b-col sm="12" class="text-right">
              <b-button size="md" variant="primary" v-if="totalRows>0" type="button" @click="downloadCSV">Download</b-button>
              </b-col> 
           <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{totalRows }}</span></b> </p>
              </b-col>        
        </b-row>
<!-- 
        <div class="col-md-12">
            <div class="panel panel-default">
               
                <div class="panel-body">
                    <div class="table-responsive"  v-if="totalRows >0">

                      <table id="dtBasicExample" class="table table-striped table-bordered table-sm" cellspacing="0" >
                          <tbody>
     
                            <th  class="table-active" v-for="item in items">{{item}}</th>
                            
                            <tr v-for="record in records">
                              <td v-for="(item, index) in items">{{record[index]}}</td>
                              
                            </tr>
                            


                          </tbody>
                      </table>

                    </div>
                    <div class="table-responsive" >
                        <table  v-if="totalRows <=0" id="dtBasicExample" class="text-center table table-striped table-bordered table-sm" cellspacing="0" >
                            <tr><td>No records available to Display.</td></tr>
                        </table>

                       

                        
                    </div>


                 
                     
                </div>
            </div>

        </div> -->
        <b-col sm="12" style="overflow: auto;">
        <b-table show-empty stacked="md"  style="text-align: left" :items="items"   :fields="fields"   :current-page="currentPage" :bordered="bordered" :per-page="perPage"  :filter="filter"       thead-class="hidden_header"  @filtered="onFiltered"   :busy="isBusy" >
         
          <template slot="top-row" >
             <td  class="totalback" v-for="record in records" ><b>{{record}}</b></td>
          
          
   
    </template>
          
         
                      
                      <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>     
                  </b-table> 
            </b-col>

                    
                    <b-col md="12" class="my-1 " v-if="this.totalRows > 10" >
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              >
            </b-pagination>
          </b-col> 

       </b-card>
        
      </b-col>
    </b-row><!--/.row-->

  </div>

</template>

<script>
import CONSTANTS from '@/utils/constants'
import Filters from '@/utils/filters'
import Utils from '@/utils'
export default {
  
  data: function() {
    return {
      name: 'codReports',
      data: [],
       records:[],
      items:[],
      fields:[],
      isBusy: false,
      breadcrumbs: [{
        text: 'Dashboard',
        href: '/dashboard'
      },{
        text: 'COD Status Report',
        active: true
      }],
      // fields: [
      //     { key: 'daname', label: 'Delivery Agent', sortable: true, sortDirection: 'desc' },
      //      { key: 'codcollectable', label: 'COD Collected', sortable: true}
      //     //   { key: 'todaypendingamount', label: 'Cod Pending-previous days', sortable: true},
      //     //     { key: 'totalpendingamount', label: 'Total Pending Cod', sortable: true}
          
      // ],
      bordered: true,
       disabled: '',
      totalRows: 0,
      currentPage: 1,
      perPage:  10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      selectDateTo: new Date(),
       selectDateFrom: new Date(),

    }
  },
  computed: {
    sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
  },
  created: function () {
    this.showCSV()
  },

  methods: {
      // info(item, index, button) {
      //   this.infoModal.title = `Row index: ${index}`
      //   this.infoModal.content = JSON.stringify(item, null, 2)
      //   this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      // },
      // resetInfoModal() {
      //   this.infoModal.title = ''
      //   this.infoModal.content = ''
      // },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    
    showCSV: function () {
      this.isBusy = true;
      //var fromdate = this.formatDate(this.selectedDate);

      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //console.log(userInfo);
      const customerGetobj = {
       
          fromdate: this.formatDate(this.selectDateFrom),
         todate: this.formatDate(this.selectDateTo),
          hub_id:`${userInfo.pickuplocationmasterid}`,
          is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
          sysemailid:`${userInfo.sysemailid}`,
            //fromdate: `${fromdate}`
      }
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/financedashboarduserwisereport`, customerGetobj)
        .then((result) => {

          // console.log("FFFFF",result.body.returnvalue[0].cashrecords);
          if (result.body.returnmsg === 'Successful') {
            this.isBusy = !this.isBusy
            //this.data = result.body.returnvalue
            this.totalRows = result.body.returnvalue[0].cashrecords.length
            // console.log("heeeeeee"+this.totalRows);
            this.records  = result.body.returnvalue[0].Heading;
            //this.items1  = result.body.returnvalue[0].Heading.length;
            //console.log("ppppppppKKKKKK"+result.body);
            this.items  = result.body.returnvalue[0].cashrecords;

           // console.log("ppppppppLLLLLLLLL"+this.records);
            //document.getElementById('refreshId').className = 'fa fa-refresh'
          } else {
            this.isBusy = !this.isBusy
            this.items  = [];
            this.records=[];
            this.totalRows = 0
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
    // Todate: function()
    // {
    //   this.model1="ture";
    // },
        downloadCSV: function() {
document.getElementById("overlay").style.display = "block";
     // alert("downloading");
   
        var userdata = localStorage.getItem('userData')
       var userInfo = JSON.parse(userdata)
      // var email=this.email;

     var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
      var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
     
     
     if(fromdate<=formatdateto)
        {

          var csvObj = {
             fromdate: `${fromdate}`,
              todate:`${formatdateto}`,
              sysusermasterid:`${userInfo.sysusermasterid}`,
               hub_id:`${userInfo.pickuplocationmasterid}`,
               is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
               sysemailid:`${userInfo.sysemailid}`,
           };


        }
        else{
          alert("Please Select Proper Dates")
          // this.$fire({
          //         text:"Please Select Proper Dates",
          //         type: "warning",
          //         timer: 30000
          //       });  
         
        }
  
  // var csvObj = {
  //            fromdate: `${fromdate}`,
  //             todate:`${formatdateto}`
  //          };

      //console.log(csvObj);
      
//         var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// console.log(queryString);
      if(formatdateto< fromdate){
        alert('To date need to be grater than From date');
         // this.$fire({
         //          text:"To date need to be grater than From date",
         //          type: "warning",
         //          timer: 30000
         //        }); 
          
      }
      //var r = Math.random().toString(36).substring(3);
      this.$http
  .post(`${CONSTANTS.MISREPORT_API_URL}/financedashboarduserwisereportcsv_advanced`,csvObj)
        .then(result => {

         console.log(result);
         document.getElementById("overlay").style.display = "none";
         if(result.body=="success")
         {
         alert("Please Check Ur Mail For Downlod Link")
           // this.$fire({
           //        text:"Please Check Ur Mail For Downlod Link",
           //        type: "success",
           //        timer: 30000
           //      }); 
       }
       else if(result.body.msg=="0"){
        alert(result.body.result);
       }
       else
       {
        alert("Can not Download");
        // this.$fire({
        //           text:"Can not Download",
        //           type: "error",
        //           timer: 30000
        //         });
       }
        //window.location.href =result.url;
        });
        
    },
    
//     downloadCSV: function() {
//      // alert("downloading");
   
//       //  var userdata = localStorage.getItem('userData')
//       // var userInfo = JSON.parse(userdata)
//       // var email=this.email;

//      var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
//       var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
     
     
//      if(fromdate<=formatdateto)
//         {

//           var csvObj = {
//              fromdate: `${fromdate}`,
//               todate:`${formatdateto}`
//            };


//         }
//         else{
//           alert("Please Select Proper Dates")
         
//         }
  
//   // var csvObj = {
//   //            fromdate: `${fromdate}`,
//   //             todate:`${formatdateto}`
//   //          };

//       //console.log(csvObj);
      
//         var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// // console.log(queryString);
//       if(formatdateto< fromdate){
//         alert('To date need to be grater than From date');
          
//       }
//       //var r = Math.random().toString(36).substring(3);
//       this.$http
//         .get(`${CONSTANTS.MISREPORT_API_URL}/financedashboarduserwisereportcsv`+queryString)
//         .then(result => {
//          // console.log(result.url);
//         window.location.href =result.url;
//         });
        
//     },
    
    


    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
  }
}
</script>
<style type="text/css">
   #overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}


/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
